import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * HeroSlider class
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.slider = document.querySelector('[data-hero-slider]');

    if (this.slider) {
      this.sliderJokes = tns({
        container: this.slider,
        mode: 'gallery',
        loop: false,
        rewind: true,
        items: 1,
        slideBy: 'page',
        arrowKeys: true,
        mouseDrag: true,
        preventScrollOnTouch: 'auto',
        nav: false,
        controls: true,
        controlsPosition: 'bottom',
        prevButton: '[data-hero-prev]',
        nextButton: '[data-hero-next]',
        autoplay: true,
        autoplayTimeout: 8000,
        autoplayButtonOutput: false,
        animateIn: 'header__hero-slide-wrapper--fade-in',
        animateOut: 'header__hero-slide-wrapper--fade-out',
      });
    }
  }
}
